/**
 * 无权限提示页面
 * 当用户没有访问权限时显示
 */

import React from 'react';
import { Result, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useMenuDataSimple } from '../../../../../hooks/useMenuDataSimple';
import { findFirstMenuPath } from '../../../../../utils/menuUtils';
import './NoPermission.css';

const NoPermission: React.FC = () => {
  const navigate = useNavigate();
  const { menuData, buildMenuTree } = useMenuDataSimple();

  // 跳转到用户有权限的第一个菜单
  const handleGoToFirstMenu = () => {
    const menuTree = buildMenuTree(menuData);
    const firstPath = findFirstMenuPath(menuTree);
    
    if (firstPath) {
      navigate(firstPath, { replace: true });
    } else {
      // 如果没有菜单，返回登录页
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="no-permission-container">
      <Result
        icon={<LockOutlined style={{ color: '#ff4d4f' }} />}
        title="无权限访问"
        subTitle={
          <div>
            <p>抱歉，您当前没有访问权限。</p>
            <p>请联系管理员分配相应的菜单权限。</p>
          </div>
        }
        extra={
          <Button type="primary" onClick={handleGoToFirstMenu}>
            返回有权限的页面
          </Button>
        }
      />
    </div>
  );
};

export default NoPermission;







